// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3GrM_","modalForm":"UpgradeEpcsModal_modalForm__20EYH","modalFooter":"UpgradeEpcsModal_modalFooter__1YK0B"};